import {
  MeterOnboardingStateProps,
  meterOnboardingState,
} from '../../atoms/meterOnboardingWizardAtom';
import React, { Fragment, useState } from 'react';
import { SDPStateProps, sdpState } from '../../atoms/sdpAtom';
import { useRecoilState, useRecoilValue } from 'recoil';

import Button from '../common/Button';
import { ReactComponent as InformationIcon } from '../../assets/information.svg';
import Input from '../forms/Input';
import InputSwitch from '../forms/InputSwitch';
import ModalInformation from '../modals/ModalInformation';
import { SDPTariffChoiceEnum } from '../../enum/SDPTariffChoiceEnum';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';
import { userPreferencesState } from '../../atoms/userPreferencesAtom/userPreferencesAtom';

export const STEP_CUSTOMIZE_METER_ID = 'customize-meter';
export default function StepCustomizeMeter() {
  const { t } = useTranslation();

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [isOpenModalTariffInformation, setIsOpenModalTariffInformation] = useState(false);

  const { previousStep, nextStep } = useWizard();
  const [meterOnboarding, setMeterOnboardingState] =
    useRecoilState<MeterOnboardingStateProps>(meterOnboardingState);
  const userPreferences = useRecoilValue(userPreferencesState);
  const sdp = useRecoilValue<SDPStateProps>(sdpState);

  const onSubmit = async (data: any) => {
    setMeterOnboardingState((state) => ({
      ...state,
      name: data.name,
      tariff: data.tariff ? SDPTariffChoiceEnum.SOCIAL : SDPTariffChoiceEnum.NONE,
    }));
    nextStep();
  };

  const handleClickTariffInfo = () => {
    setIsOpenModalTariffInformation(true);
  };

  const handleClickActionTariffInfo = () => {
    setIsOpenModalTariffInformation(false);
  };

  const getInfoContent = () => (
    <Fragment>
      <h2>{t('step.customize.meter.tariff.information.card.first')}</h2>
      <p>{t('step.customize.meter.tariff.information.card.second')}</p>
      <p>{t('step.customize.meter.tariff.information.card.third')}</p>
    </Fragment>
  );

  return (
    <div className="wizard step-customize-meter" data-test-id={`step-${STEP_CUSTOMIZE_METER_ID}`}>
      <form className="form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form__container">
          <Input
            label={t('step.customize.meter.name.input.label')}
            className="input--compact"
            type="text"
            name="name"
            error={
              errors.name?.type === 'maxLength'
                ? t('step.customize.meter.name.input.error.maxLength')
                : undefined
            }
            validations={{ maxLength: 20 }}
            placeholder={t('step.customize.meter.name.input.legend')}
            register={register}
          />
          {meterOnboarding.eanEligibilityOutResponse.isCapable &&
            meterOnboarding.eanEligibilityOutResponse.isSmart &&
            meterOnboarding.isAccMember === false && (
              <Fragment>
                <InputSwitch
                  label={t('step.customize.meter.name.input.tariff')}
                  name="tariff"
                  control={control}
                  className="input--with-info"
                  defaultValue={
                    sdp.items?.find((item) => item.id === userPreferences.selectedSdpId)
                      ?.tariffChoice === SDPTariffChoiceEnum.SOCIAL
                      ? true
                      : false
                  }
                  suffix={<InformationIcon onClick={handleClickTariffInfo} />}
                />
              </Fragment>
            )}
        </div>

        <div className="wizard__actions">
          <Button className="btn btn--secondary" onClick={previousStep}>
            {t('common.back')}
          </Button>
          <Button type="submit" className="btn btn--primary">
            {t('common.terminate')}
          </Button>
        </div>
      </form>
      <ModalInformation
        isOpen={isOpenModalTariffInformation}
        onClickAction={handleClickActionTariffInfo}
      >
        {getInfoContent()}
      </ModalInformation>
    </div>
  );
}
